import { useQuery } from '@tanstack/react-query';
import { License } from '@webdev/user-management';
import { useMemo } from 'react';
import { licenseAssignationKey } from './licenseAssignationKey';
import { useUserManagementClientContext } from './UserManagementClientContext';

export const useGetUsersByLicense = (licenseId: License['id']) => {
  const client = useUserManagementClientContext();

  const { data, isLoading } = useQuery({
    queryKey: [licenseAssignationKey, 'byLicenseId'],
    queryFn: () => client.getAllManagedUsersByLicenses(),
  });

  const usersAssigned = useMemo(() => (data && data[licenseId]) ?? [], [data, licenseId]);
  return { usersAssigned, isLoading };
};
